import { Tag } from "antd";
import React from "react";
import { $t } from "~/i18n.js";
import { AuthorisationIndicator } from "./AuthorisationIndicator.jsx";

export const ShowAuthorisation = ({
  vlieger = {},
  isUser = false,
  canAuthorize = false,
  canRevoke = false,
}) => {

  if (!vlieger.has_signed_in_today) {
    return (
      <Tag>
        {$t("Vliegt niet vandaag")}
      </Tag>
    );
  }

  // Create aanmelding-like object for AuthorizationIndicator
  const aanmelding = {
    id: vlieger.aanmelding_id || vlieger.id,
    authorised: vlieger.authorised,
    requires_authorisation: vlieger.requires_authorisation,
    vlieger: {
      id: vlieger.id,
      name: vlieger.name,
    },
  };

  return (
    <AuthorisationIndicator
      aanmelding={aanmelding}
      isUser={isUser}
      canAuthorize={canAuthorize}
      onAuthorize={null}
      canRevoke={canRevoke}
    />
  );
};
